module.exports = function() {
  return new Worker(__webpack_public_path__ + "93493f39f9c0ab0b18da.worker.js");
};